export default {"src":"/_next/static/media/decrease-timeline.309931c6.svg","height":151,"width":151,"blurWidth":0,"blurHeight":0};